import { FC, ReactNode } from "react";

interface BFLToggleButtonWrapperProps {
  children: ReactNode;
}

const BFLToggleButtonWrapper: FC<BFLToggleButtonWrapperProps> = ({
  children,
}) => {
  return (
    <div className="align-center flex gap-[10px] pb-1 pt-8 md:pb-4 md:pt-6">
      {children}
    </div>
  );
};

export default BFLToggleButtonWrapper;
